<template>
  <div class="sidebar-layout white-background d-flex flex-grow-1 overflow-hidden">
    <div class="sidebar-layout__sidebar border-end d-flex flex-column" :style="{ width: sidebarWidth }">
      <div v-if="$slots.search" class="p-3 border-bottom">
        <slot name="search" />
      </div>
      <div class="sidebar-layout__scroll">
        <slot name="sidebar" />
      </div>
    </div>
    <div class="sidebar-layout__content">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  sidebarWidth?: string;
}

withDefaults(defineProps<Props>(), {
  sidebarWidth: '320px',
});
</script>

<style scoped>
.sidebar-layout {
  height: calc(100vh - 60px);
}

.sidebar-layout__sidebar {
  flex-shrink: 0;
  background: rgb(246, 249, 252);
}

.sidebar-layout__scroll {
  flex-grow: 1;
  overflow-y: auto;
}

.sidebar-layout__content {
  flex-grow: 1;
  overflow-y: auto;
  background-color: #fff;
}
</style>

<style>
.sidebar-layout__scroll {
  scrollbar-width: thin;
  scrollbar-color: transparent transparent;
}

.sidebar-layout__scroll:hover {
  scrollbar-color: rgba(0, 0, 0, 0.15) transparent;
}
</style>
